import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class ExtractionOutputFileTemplatesService {
  getExtractionOutputFileTemplates({ cancelToken = null }) {
    return ApiService.get(`${Config.api.slipExtractor.url}api/v1/extraction-output-file-templates`, {
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }

  addExtractionOutputFileTemplate({ file, cancelToken = null }) {
    return ApiService.post(`${Config.api.slipExtractor.url}api/v1/extraction-output-file-templates`, file, {
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }

  deleteExtractionOutputFileTemplate({ templateId }) {
    return ApiService.delete(
      `${Config.api.slipExtractor.url}api/v1/extraction-output-file-templates/${templateId}`,
    ).then((response) => response.data);
  }
}

export const extractionOutputFileTemplatesService = new ExtractionOutputFileTemplatesService();
